// Centre-specific DICOMweb proxy handling.
//
// The login response may include `dicomProxy` — the DICOMweb RS base
// (<rad_centres.proxy_url>/rs) for the user's primary centre. We keep it in
// plain localStorage (it's just a URL, not a secret) so that:
//   - it survives into the separate viewer tabs (sessionStorage doesn't reliably)
//   - public/config/default.js, a plain pre-boot script, can read it synchronously
//     when building window.config.dataSources.
// When the key is absent, the app falls back to the central ENV_CONFIG URLs.

export const DICOM_PROXY_STORAGE_KEY = 'dicom_proxy';

// Login-time snapshot: always called on login so a proxy-less user (or centre)
// clears any value left behind by a previous login on the same browser.
export const setDicomProxy = (url) => {
  try {
    if (url) {
      localStorage.setItem(DICOM_PROXY_STORAGE_KEY, url);
    } else {
      localStorage.removeItem(DICOM_PROXY_STORAGE_KEY);
    }
  } catch (e) {
    console.error('Failed to store dicom proxy:', e);
  }
};

export const clearDicomProxy = () => {
  try {
    localStorage.removeItem(DICOM_PROXY_STORAGE_KEY);
  } catch (e) {
    // ignore
  }
};

export const getDicomProxy = () => {
  try {
    return localStorage.getItem(DICOM_PROXY_STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
};
